import { render } from "./NewDonorQuestionnaireForm.vue?vue&type=template&id=c622c8f2&scoped=true"
import script from "./NewDonorQuestionnaireForm.vue?vue&type=script&lang=js"
export * from "./NewDonorQuestionnaireForm.vue?vue&type=script&lang=js"

import "./NewDonorQuestionnaireForm.vue?vue&type=style&index=0&id=c622c8f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c622c8f2"]])

export default __exports__